import { useEffect, useState, useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
    Divider,
    Paper,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'HkTaskName', label: 'Task', minWidth: 70 },
    { id: 'Abrv', label: 'Abbrivation', minWidth: 70 },
    { id: 'Remark', label: 'Remark', minWidth: 70 },
];

const Yojanamst = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [isPreviousDisabled, setIsPreviousDisabled] = useState(false);
    const [isNextDisabled, setIsNextDisabled] = useState(false);
    const [selected, setSelected] = useState([])
    console.log('selected', selected)
    const [formData, setFormData] = useState({
        YojanaName: '',
        Abrv: '',
        Remark: '',
    });

    const [error, setError] = useState({
        YojanaName: false,
        Abrv: false,
    });

    const navigate = useNavigate();
    const location = useLocation();

    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [currentYojana, setCurrentYojana] = useState(null);
    const [mode, setMode] = useState('view');
    const [status, setStatus] = useState("1");
    const [lastInsertedYojanaId, setLastInsertedYojanaId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [userId] = useState(sessionStorage.getItem('UserId'));
    const [dataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const [selectedYojanas, setSelectedYojanas] = useState([]);

    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const yojanaNameRef = useRef(null);
    const abrvRef = useRef(null);
    const remarkRef = useRef(null);

     const globalProperty = useSelector(selectGlobalProperty);

    useEffect(() => {
        const getTasks = async () => {
            const params = {
                start: 0,
                PageSize: 100,
                SearchText: "",
            };
            try {
                const res = await axiosInstance.post('MstHkTask/getMstHkTaskDashBoard', { params });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                toast.error('Error fetching tasks:', err);
            }
        };
        getTasks();
    }, []);

    useEffect(() => {
        if (location.state && location.state.YojanaId) {
            setCurrentYojana(location.state.YojanaId);
            fetchYojanaData(location.state.YojanaId, "R");
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
            setSelectedYojanas([]);
        }
    }, [location]);

    const fetchYojanaData = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstYojana/RetriveMstYojanaAll`, {
                YojanaId: parseInt(id),
                Flag: flag,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const yojanaData = response.data.Data.MstYojanaDtlEntities[0];
                const checked = response.data.Data.MstYojanaDtlEntities[0].MstYojanaEntities;
                setSelected(checked)
                setFormData({
                    YojanaName: yojanaData.YojanaName || '',
                    Abrv: yojanaData.Abrv || '',
                    Remark: yojanaData.Remark || '',
                });
                setStatus(yojanaData.status?.toString() || "1");

                setCurrentYojana(yojanaData.YojanaId);

                if (yojanaData.MstYojanaEntities && yojanaData.MstYojanaEntities.length > 0) {
                    const selectedTaskIds = yojanaData.MstYojanaEntities.map(item => item.HkTaskId);
                    setSelectedYojanas(selectedTaskIds);

                } else {
                    setSelectedYojanas([]);
                }
                setIsPreviousDisabled(false);
                setIsNextDisabled(false);

            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                if (flag === "P") {
                    setIsPreviousDisabled(true);
                    if (currentYojana <= 1) {
                        setIsPreviousDisabled(true);
                    }
                } else if (flag === "N") {
                    setIsNextDisabled(true);
                }
            } else {
                toast.info(response.data.Message || 'No record Found.');
            }
        } catch (error) {
            console.error('Error while fetching yojana:', error);
            toast.error('Error while fetching yojana.');
        }
    };
    const deleteYojanaData = async (id) => {
        try {
            const response = await axiosInstance.post(`MstYojana/DeleteMstYojana`, {
                YojanaId: parseInt(id),
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || 'Data deleted successfully.');
                return true;
            } else {
                toast.info(response.data.Message || 'Failed to delete record.');
                return false;
            }
        } catch (error) {
            console.error('Error while deleting yojana:', error);
            toast.error('Error while deleting yojana.');
            return false;
        }
    };

    const handlePrevious = async () => {
        if (currentYojana && currentYojana > 1 && !isPreviousDisabled) {
            await fetchYojanaData(currentYojana, "P");
        }
    };

    const handleNext = async () => {
        if (currentYojana) {
            await fetchYojanaData(currentYojana, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === yojanaNameRef.current) {
                abrvRef.current.focus();
            } else if (event.target === abrvRef.current) {
                remarkRef.current.focus();
            }
        }
    };

    const handleCheckboxChange = (HkTaskId, isChecked) => {
        if (isChecked) {
            setSelectedYojanas(prev => [...prev, HkTaskId]);
        } else {
            setSelectedYojanas(prev => prev.filter(id => id !== HkTaskId));
        }
    };

    const handleSubmit = async () => {
        let hasError = false;

        if (!formData.YojanaName) {
            toast.error('Yojana Name is required');
            setError((prev) => ({ ...prev, YojanaName: true }));
            yojanaNameRef.current?.focus();
            hasError = true;
        } else {
            setError((prev) => ({ ...prev, YojanaName: false }));
        }

        if (hasError) return;

        try {
            let previousSelectedTasks = [];
            let existingYojanaDetails = [];

            if (mode === 'edit' && currentYojana) {
                try {
                    const fetchResponse = await axiosInstance.post(`MstYojana/RetriveMstYojanaAll`, {
                        YojanaId: parseInt(currentYojana),
                        Flag: "R",
                    });

                    if (fetchResponse.data.Status === 0 && fetchResponse.data.responseStatusCode === 1) {
                        const yojanaData = fetchResponse.data.Data.MstYojanaDtlEntities[0];
                        previousSelectedTasks = yojanaData.MstYojanaEntities || [];
                        existingYojanaDetails = previousSelectedTasks;
                    }
                } catch (fetchError) {
                    console.error('Error fetching existing yojana details:', fetchError);
                }
            }

            const MstYojanaEntities = [];
            const existingTaskIds = existingYojanaDetails.map(item => item.HkTaskId);
            const previousTaskIds = previousSelectedTasks.map(item => item.HkTaskId);

            selectedYojanas.forEach(HkTaskId => {
                const existingEntry = existingYojanaDetails.find(item => item.HkTaskId === HkTaskId);

                if (existingEntry) {
                    MstYojanaEntities.push({
                        DBFLAG: "U",
                        YojanaDtlId: existingEntry.YojanaDtlId.toString(),
                        YojanaId: currentYojana?.toString() || "0",
                        HkTaskId: HkTaskId.toString()
                    });
                } else {
                    MstYojanaEntities.push({
                        DBFLAG: "I",
                        YojanaDtlId: "0",
                        YojanaId: currentYojana?.toString() || "0",
                        HkTaskId: HkTaskId.toString()
                    });
                }
            });

            previousTaskIds.forEach(HkTaskId => {
                if (!selectedYojanas.includes(HkTaskId)) {
                    const removedEntry = existingYojanaDetails.find(item => item.HkTaskId === HkTaskId);
                    if (removedEntry) {
                        MstYojanaEntities.push({
                            DBFLAG: "D",
                            YojanaDtlId: removedEntry.YojanaDtlId.toString(),
                            YojanaId: currentYojana?.toString() || "0",
                            HkTaskId: HkTaskId.toString()
                        });
                    }
                }
            });
            const payload = {
                YojanaName: formData.YojanaName,
                Abrv: formData.Abrv || '',
                PropId: globalProperty || 0,
                Status: status,
                Remark: formData.Remark || '',
                CreatedBy: parseInt(userId, 10),
                DBFLAG: mode === 'edit' ? 'U' : 'I',
                MstYojanaEntities: MstYojanaEntities
            };

            if (mode === 'edit' && currentYojana) {
                payload.YojanaId = currentYojana.toString();
                payload.UpdatedBy = parseInt(userId, 10);

                existingYojanaDetails.forEach(existingItem => {
                    const alreadyInArray = MstYojanaEntities.some(item =>
                        item.YojanaDtlId === existingItem.YojanaDtlId.toString()
                    );

                    if (!alreadyInArray) {
                        MstYojanaEntities.push({
                            DBFLAG: "R",
                            YojanaDtlId: existingItem.YojanaDtlId.toString(),
                            YojanaId: currentYojana.toString(),
                            HkTaskId: existingItem.HkTaskId.toString()
                        });
                    }
                });
            }

            const response = await axiosInstance.post(`/MstYojana/MangeMstYojana`, payload);

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);

                if (mode === 'add') {
                    const newYojanaId = response.data.Data?.YojanaId || response.data.Data;
                    if (newYojanaId) {
                        setLastInsertedYojanaId(newYojanaId);
                        await fetchYojanaData(newYojanaId, "R");
                        setCurrentYojana(newYojanaId);
                    }
                    setMode('view');
                    setIsFormDisabled(true);
                } else {
                    await fetchYojanaData(currentYojana, "R");
                    setMode('view');
                    setIsFormDisabled(true);
                    if (currentYojana) {
                        await UnLock(currentYojana, "MstYojana", "YojanaId");
                    }
                }
            } else {
                toast.info(response.data.Message || 'Operation failed.');
            }
        } catch (error) {
            console.error('Error while saving Yojana:', error);
            toast.error('Error while saving Yojana.');
        }
    };

    const handleEdit = async () => {
        let flag = await checkAndLock(currentYojana, "MstYojana", "YojanaId");
        switch (flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked.", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock.", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong.", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            YojanaName: '',
            Abrv: '',
            Remark: '',
        });
        setCurrentYojana(null);
        setStatus("1");
        setSelectedYojanas([]);

        setTimeout(() => {
            yojanaNameRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            if (mode === 'edit' && currentYojana) {
                await fetchYojanaData(currentYojana, "R");
                await UnLock(currentYojana, "MstYojana", "YojanaId");
            } else if (mode === 'add') {
                if (lastInsertedYojanaId) {
                    await fetchYojanaData(lastInsertedYojanaId, "R");
                    setCurrentYojana(lastInsertedYojanaId);
                } else {
                    setIsFormDisabled(true);
                    setFormData({
                        YojanaName: '',
                        Abrv: '',
                        Remark: '',
                    });
                    setSelectedYojanas([]);
                }
            }
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const handleExit = () => {
        navigate('/yojana-master');
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        const flag = await checkAndLock(currentYojana, "MstYojana", "YojanaId");
        switch (flag) {
            case 0:
                setOpenConfirmDialog(false);
                await deleteYojanaData(currentYojana);
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
                setSelectedYojanas([]);
                // toast.success("Record deleted successfully.");
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container" sx={{
                width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "92vh" },
                overflowX: "hidden",
                overflowY: { xs: "auto", sm: "hidden", md: "hidden", lg: "hidden" },
            }}>
                <ToastContainer />
                <Grid container spacing={1} className="form_grid">
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '7px', sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '7px' }, display: 'block' }}
                                disabled={mode !== 'view' || !currentYojana || currentYojana === 1 || isPreviousDisabled}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: 'block' }}
                                disabled={mode !== 'view' || !currentYojana || isNextDisabled}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' },
                            }}
                        >
                            Yojana Master
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName="Yojana Master"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12} md={6} lg={5}>
                                <TextField
                                    id="YojanaName"
                                    name="YojanaName"
                                    label={
                                        <span>
                                            Yojana Name <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.YojanaName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.YojanaName}
                                    helperText={error.YojanaName && "Yojana Name is required"}
                                    inputRef={yojanaNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={5}>
                                <TextField
                                    id="Abrv"
                                    name="Abrv"
                                    label="Abbreviation/Code"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Abrv}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={abrvRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={10} lg={9}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={4} md={2} lg={1}>
                                <Box display="flex" justifyContent="center">
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={isFormDisabled}
                                                    checked={status === "1"}
                                                    onChange={handleChangeStatus}
                                                />
                                            }
                                            label="Status"
                                        />
                                    </FormGroup>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Box display="flex" justifyContent="center">
                            <Box width="50%">

                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                            Task List: {selectedYojanas.length > 0 && (
                                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                    Selected: {selectedYojanas.length} task(s)
                                                </Typography>
                                            )}
                                        </Typography>

                                        <TextField
                                            id="search-yojana"
                                            placeholder="Search Task..."
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                width: '200px',
                                                mb: 1,
                                                '& .MuiOutlinedInput-root': {
                                                    height: '32px'
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '6px 8px',
                                                    fontSize: '0.875rem'
                                                }
                                            }}
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            InputProps={{
                                                endAdornment: searchQuery && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => setSearchQuery('')}
                                                        sx={{ mr: -1, p: 0.5 }}
                                                    >
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </Box>

                                    <Box sx={{
                                        display: 'grid',
                                        gridTemplateColumns: {
                                            xs: 'repeat(1, 1fr)',
                                            sm: 'repeat(2, 1fr)',
                                            md: 'repeat(3, 1fr)',
                                            lg: 'repeat(6, 1fr)',
                                        },
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        padding: '8px',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                        backgroundColor: '#f9f9f9',
                                        gap: '2px',
                                    }}>
                                        {rows
                                            .filter(row =>
                                                searchQuery === '' ||
                                                row.HkTaskName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                                (row.Abrv && row.Abrv.toLowerCase().includes(searchQuery.toLowerCase()))
                                            )
                                            .map((row) => (
                                                <FormControlLabel
                                                    key={row.HkTaskId}
                                                    control={
                                                        <Checkbox
                                                            size="small"
                                                            checked={selectedYojanas.includes(row.HkTaskId)}
                                                            onChange={(e) => handleCheckboxChange(row.HkTaskId, e.target.checked)}
                                                            disabled={isFormDisabled}
                                                            sx={{
                                                                margin: 0,
                                                                padding: 0,
                                                                transform: 'scale(0.8)',
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontSize: '0.875rem',
                                                                marginLeft: '4px',
                                                            }}
                                                        >
                                                            {row.HkTaskName} {row.Abrv && `(${row.Abrv})`}
                                                        </Typography>
                                                    }
                                                    sx={{
                                                        margin: 0,
                                                        padding: 0,
                                                    }}
                                                />
                                            ))}
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button" sx={{ p: 0 }}>
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }}
                                    onClick={handleAdd}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }}
                                    onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(dataForPrint).length > 0 && (
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Yojana Master"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: '#f5f5f5' }}
                    />
                )}
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this Yojana record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Yojanamst;